









import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

export default Vue.extend({
    name: 'Admin',
    computed: {
        ...mapState('auth', ['user']),
        ...mapGetters('user-options', { getUserOptions: 'get' })
    },
    data() {
        return {
            loading: false
        };
    },
    async mounted() {
        this.loading = true;
        if(window.localStorage.getItem('feathers-jwt')) {
            await this.authenticate({
                strategy: 'jwt',
                accessToken: window.localStorage.getItem('feathers-jwt')
            }).then(async () => {
                await this.$initialRoleStatus();
                if(this.$route.path === '/login') {
                    this.$router.push('/');
                }
            }).catch(err => {
                this.$router.push('/login');
            });
        } else {
            if(this.$route.path === '/login') {
                if(this.user) {
                    await this.$initialRoleStatus();
                    this.$router.push('/');
                }
            } else {
                if(!this.user) {
                    this.$router.push('/login');
                }
            }
        }
        this.loading = false;
    },
    methods: {
        ...mapActions('auth', ['authenticate'])
    },
    components: {
        DashboardLayout: DashboardLayout
    }
})
